import { useState, useEffect } from "react";
import { Chakra } from "@airhelp/react-ui-components";
import PropTypes from "prop-types";

import SubmenuContent from "./SubmenuContent";

const { Box, Menu, MenuButton, MenuList } = Chakra;

const menuButtonStyles = {
  span: {
    color: "primary.900",
  },
  ":hover": {
    span: {
      color: "primary.500",
    },
  },
};

const MenuLinkWithSubmenuDesktop = ({ menulink, submenu }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [menuStateTimeout, setMenuStateTimeout] = useState(null);

  const menuStateHandler = (state, miliseconds) => {
    setMenuStateTimeout(setTimeout(() => setMenuOpen(state), miliseconds));
  };

  useEffect(() => () => clearTimeout(menuStateTimeout), [menuStateTimeout]);

  return (
    <Box onMouseEnter={() => menuStateHandler(true, 300)} onMouseLeave={() => menuStateHandler(false, 0)}>
      <Menu isOpen={menuOpen} bg="black">
        <MenuButton sx={menuButtonStyles}>{menulink}</MenuButton>
        <MenuList
          border="none"
          boxShadow="none"
          rounded="md"
          borderTopLeftRadius="none"
          textAlign="left"
          pt={4}
          pb={0}
          mt={-2}
        >
          <Box rounded="md" mt={2} boxShadow="md" zIndex="2" data-testid="kyr-menu">
            <SubmenuContent
              submenu={submenu}
              color="greyscale.600"
              _hover={{ color: "primary.900", bg: "greyscale.300" }}
              px={4}
              py={2.5}
              mb={0}
              rounded="md"
            />
          </Box>
        </MenuList>
      </Menu>
    </Box>
  );
};

export default MenuLinkWithSubmenuDesktop;

MenuLinkWithSubmenuDesktop.propTypes = {
  menulink: PropTypes.node.isRequired,
  submenu: PropTypes.arrayOf(
    PropTypes.shape({
      page: PropTypes.string,
      label: PropTypes.string,
    })
  ),
};
